import { render } from "./BooleanGroupField.vue?vue&type=template&id=23e71c97"
import script from "./BooleanGroupField.vue?vue&type=script&lang=js"
export * from "./BooleanGroupField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thuanluu/code/owlx/more9_venues/package/private/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"BooleanGroupField.vue"]])

export default __exports__